// Hoists the active view's page TITLE into the top panel next to the notification
// bell and user profile. Only the title moves — each view keeps its subtitle and
// its action buttons where they were authored, they simply move up into the space
// the title used to take.
//
// The titles stay authored inside their views (ids and listeners are wired there);
// this module only relocates the live DOM node — moving an element keeps its
// listeners, so nothing needs re-binding. Each title leaves an anchor behind,
// which doubles as the visibility probe: a view that is hidden, or a wrapper like
// #dashboard-active-state that is toggled off, hides its anchor, and a title with
// no visible anchor is never hoisted.

const slot = document.getElementById('top-header-title');

// [{ title, anchor }] — captured once, before anything is moved.
const registry = [];
let registered = false;
let hoisted = null;

function add(title) {
    const anchor = document.createElement('div');
    anchor.className = 'page-title-anchor';
    title.parentNode.insertBefore(anchor, title);
    registry.push({ title, anchor });
}

function register() {
    if (registered) return;
    registered = true;
    // The watched tournament's name comes first: while spectating it is the title
    // that belongs in the top panel on every tab, and the views' own titles are
    // arbiter-only anyway.
    const spectatorName = document.getElementById('spectator-display-name');
    if (spectatorName) add(spectatorName);
    document.querySelectorAll('.view .page-title').forEach(add);
}

// An anchor with no offsetParent is inside a display:none subtree (an inactive
// view, or a hidden state wrapper) — that view's title must stay put.
function isAnchorVisible(anchor) {
    return anchor.offsetParent !== null;
}

/**
 * Moves the currently visible view's page title into the top panel and returns
 * any previously hoisted title to its own view. Safe to call repeatedly.
 */
export function syncTopHeader() {
    if (!slot) return;
    register();

    // Measure with the slot shown — `.is-empty` hides it, and a hidden slot would
    // report the title it already holds as collapsed.
    slot.classList.remove('is-empty');

    // A title can be role-gated on its own (the arbiter-only "Round Management"
    // heading sits in a container that stays visible while spectating), so prefer
    // a candidate that actually renders; falling back to the first one keeps the
    // "nothing to show" case below working.
    const candidates = registry.filter(entry => isAnchorVisible(entry.anchor));
    const target = candidates.find(entry => entry.title.offsetHeight > 0) || candidates[0] || null;

    if (hoisted && hoisted !== target) {
        hoisted.anchor.parentNode.insertBefore(hoisted.title, hoisted.anchor);
        hoisted = null;
    }

    if (target) {
        if (target.title.parentNode !== slot) slot.appendChild(target.title);
        hoisted = target;
    }

    // Nothing visible to carry (the Landing view, or a spectator on a tab whose
    // heading is arbiter-only) — drop the slot so the profile block keeps sitting
    // flush right.
    if (!target || target.title.offsetHeight === 0) slot.classList.add('is-empty');
}
